// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__V98wW","form":"Details_form__11yjp"};